<template>
  <div>
    <div
      class="px-4 sm:px-6 md:px-8 mb-8 flex items-center justify-between flex-wrap sm:flex-no-wrap"
    >
      <div class="max-w-7xl">
        <h1 class="text-2xl font-semibold text-gray-900">Projets</h1>
      </div>
      <div class="flex-shrink-0">
        <span class="inline-flex rounded-md shadow-sm">
          <button
            @click="openModal"
            type="button"
            class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
          >
            Ajouter un nouveau projet
          </button>
        </span>
      </div>
    </div>

    <div class="px-4 sm:px-6 md:px-8 mt-4">
      <div class="flex flex-col">
        <div
          class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
        >
          <div class="bg-white shadow overflow-hidden sm:rounded-md">
            <ul>
              <project-row
                v-for="project in projects"
                :key="project.id"
                :project="project"
              ></project-row>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <add-project-modal :open="open" @close="closeModal"></add-project-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ProjectRow from "@/components/Projects/ProjectRow";
import AddProjectModal from "@/components/Projects/AddProjectModal";
export default {
    components: {
        ProjectRow,
        AddProjectModal
    },
    data() {
        return {
            open: false
        };
    },
    computed: {
        ...mapState("project", ["projects"]),
        hasProjects() {
            return this.projects.length > 0;
        }
    },
    methods: {
        openModal() {
            this.open = true;
        },
        closeModal() {
            this.open = false;
        },
        goToDetail(project) {
            this.$router.push({
                name: "projects-detail",
                params: { id: project.public_id }
            });
        },
        create(body) {
            console.log("create");
            console.log(body);
            // const bodyWithCompany = { ...body, company_id: this.company.id };
            // console.log(bodyWithCompany);
            // this.$store.dispatch("company/createUser", bodyWithCompany).then(res => {
            //   if (res.status === 200) {
            //     this.open = false;
            //   }
            // });
        }
    },
    mounted() {
        this.$store.dispatch("project/get");
    }
};
</script>
